import { render } from "./LoginOrSignup.vue?vue&type=template&id=ff773c20"
import script from "./LoginOrSignup.vue?vue&type=script&lang=js"
export * from "./LoginOrSignup.vue?vue&type=script&lang=js"

import exportComponent from "/Users/carterharrison/Documents/github/cf/api-platform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__